import React from 'react';
import Drawer, { DrawerProps } from '@mui/material/Drawer';
import { styled } from '@mui/material';
import useGetPlatformInfo from 'hooks/useGetPlatformInfo';

const StyledDrawer = styled(Drawer)(() => ({
    '& .MuiDrawer-paper': {
      width: '85%',
      '@media (min-width: 600px)': {
        width: '75%',
      },
      '@media (min-width: 960px)': {
        width: '40%',
      },
    },
}));

const FullScreenCartDrawer = styled(Drawer)(() => ({
    '& .MuiDrawer-paper': {
        width: '100vw',
        maxWidth: '100vw',
        height: '100dvh',
        overflow: 'hidden',
        borderRadius: 0,
    },
}));

function CartDrawer(props: DrawerProps) {
    const { isShellApp } = useGetPlatformInfo();
    if (isShellApp) {
        return (
            <FullScreenCartDrawer {...props} />
        );
    }
    return (
        <StyledDrawer {...props} />
    );
}

export default CartDrawer;
